import template from "@/http/requests/newsletter/template"

export default {
  fetch({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      template.fetch(queryData).then(response => {
        commit('SET_TEMPLATES', response.data.data.newsletterTemplates)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      template.add(data).then(response => {
        commit('ADD_TEMPLATE', response.data.data.createNewsletterTemplate)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      template.update(data).then(response => {
        commit('UPDATE_TEMPLATE', response.data.data.updateNewsletterTemplate)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, templateId) {
    return new Promise((resolve, reject) => {
      template.delete(templateId).then(response => {
        commit('DELETE_TEMPLATE', templateId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, templateId) {
    return new Promise((resolve, reject) => {
      template.infos(templateId).then(response => {
        commit('ADD_TEMPLATE_INFOS', response.data.data.newsletterTemplateInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
